import { render, staticRenderFns } from "./MicCheck.vue?vue&type=template&id=3b96742c&scoped=true"
import script from "./MicCheck.vue?vue&type=script&lang=js"
export * from "./MicCheck.vue?vue&type=script&lang=js"
import style0 from "./MicCheck.vue?vue&type=style&index=0&id=3b96742c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96742c",
  null
  
)

export default component.exports